export default defineNuxtRouteMiddleware((to, from) => {
	const fat = useFatStore()

	// Clear selection state when navigating away from offers
	if (from.name === 'offers-city') {
		fat.clearSelectedRestaurant()
	}
})
